import { Component, Input, OnDestroy, OnInit, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { CruiseFiltersService } from '@app/services/cruis/cruisefilters.service';
import { CruiseService } from '@app/services/cruise.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { cruisesearchTypes, cruisegsPrice, cruisecabinCat, cruiselanguage, cruisemaxPass, cruisereiseDauer } from '../tools/CruiseStatic';
interface Item {
    id: string;
    name: string;
    selected?: boolean;
    description?: string;
    land?: string;
};
@Component({
    selector: 'app-cruiseextrafilters',
    templateUrl: './cruiseextrafilters.component.html',
    styleUrls: ['./cruiseextrafilters.component.scss'],
    standalone: false
})
export class CruiseextrafiltersComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Output() closeModal: EventEmitter<boolean> = new EventEmitter();

    cruisesearchtypedata: string = '';
    specialcode: string = '';

    cruisedurationdata: string = '';

    cruiseboardlanguagedata: string = '';

    cruisemaxanzpassdata: string = '';

    cruisemaxpricedata: string = '';

    cruisecabincatdata: string = '';

    desktopTemplate: string = 'xl';
    showSmallMode: boolean = false;
    loading: boolean = false;

    currentpartner: Partner;
    protected unsubscribe$ = new Subject();
    searchTypes: Item [];
    reiseDauer: Item [];
    maxPass: Item [];
    cabinCat: Item [];
    gsPrice: Item [];
    language: Item [];

    constructor(
        protected cruiseFiltersService: CruiseFiltersService,
        protected cruiseService: CruiseService,
        protected mediaObserver: BreakpointObserver,
        protected guardService: AuthGuardService,
        protected cdr: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        this.searchTypes = JSON.parse(JSON.stringify(cruisesearchTypes));
        this.reiseDauer = JSON.parse(JSON.stringify(cruisereiseDauer));
        this.maxPass = JSON.parse(JSON.stringify(cruisemaxPass));
        this.cabinCat = JSON.parse(JSON.stringify(cruisecabinCat));
        this.gsPrice = JSON.parse(JSON.stringify(cruisegsPrice));
        this.language = JSON.parse(JSON.stringify(cruiselanguage));
        this.initMedia();
        this.initPartner();
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((partner) => {
            if (partner?.partnerid?.length > 0) {
                this.currentpartner = partner;
                this.initFilters();
            }
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    async initFilters() {
        this.cruiseFiltersService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(params => {
            if (params) {
                this.cruisesearchtypedata = params.cruisesuchetype;
                this.cruisedurationdata = params.cruiseduration;
                this.cruiseboardlanguagedata = params.cruiseboardlanguage;
                this.specialcode = params.promo;
                this.cruisemaxpricedata = params.cruisemaxprice;
                this.cruisecabincatdata = params.cruisecabincat;
                this.cruisemaxanzpassdata = params.cruisemaxanzpass;
                this.checkSelections();
            }
        });
    }

    async checkSelections() {
        this.searchTypes = JSON.parse(JSON.stringify(this.checkData(this.searchTypes, this.cruisesearchtypedata)));
        this.reiseDauer = JSON.parse(JSON.stringify(this.checkData(this.reiseDauer, this.cruisedurationdata)));
        this.maxPass = JSON.parse(JSON.stringify(this.checkData(this.maxPass, this.cruisemaxanzpassdata)));
        this.cabinCat = JSON.parse(JSON.stringify(this.checkData(this.cabinCat, this.cruisecabincatdata)));
        this.gsPrice = JSON.parse(JSON.stringify(this.checkData(this.gsPrice, this.cruisemaxpricedata)));
        this.language = JSON.parse(JSON.stringify(this.checkData(this.language, this.cruiseboardlanguagedata)));
    }

    checkData(array, selected): any[] {
        for (let i = 0; i < array.length; i++) {
            array[i].selected = array[i].id === selected;
        }
        return array;
    }

    checkListData(array, selected): any[] {
        if (array?.length > 0 && selected?.length > 0) {
            for (let i = 0; i < array?.length; i++) {
                for (let j = 0; j < selected?.length; j++) {
                    if (array[i].id === selected[j].code) {
                        array[i].selected = true;
                    }
                }
            }
        } else if (selected?.length > 0) {
            array = [];
            for (let j = 0; j < selected?.length; j++) {
                array.push({
                    id: selected[j].code,
                    name: selected[j].name,
                    selected: true
                })
            }
        }
        return array;
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    cruisesearchtyperesult(ev): void {
        this.cruisesearchtypedata = ev?.id;
        this.cruiseFiltersService.cruisesuchetype(this.cruisesearchtypedata, this.mode !== 'home');
    }

    async cruisedurationresult(ev) {
        this.cruisedurationdata = ev?.id;
        this.cruiseFiltersService.cruiseduration(this.cruisedurationdata, this.mode !== 'home');
    }

    async setSpecial(ev) {
        this.cruiseFiltersService.promo(ev);
        // this.cruiseFiltersService.pmc(ev);
    }

    async cruiseboardlanguageresult(ev) {
        this.cruiseboardlanguagedata = ev?.id;
        this.cruiseFiltersService.cruiseboardlanguage(this.cruiseboardlanguagedata, this.mode !== 'home');
    }

    async cruisemaxanzpassresult(ev) {
        this.cruisemaxanzpassdata = ev?.id;
        this.cruiseFiltersService.cruisemaxanzpass(this.cruisemaxanzpassdata, this.mode !== 'home');
    }

    async cruisemaxpriceresult(ev) {
        this.cruisemaxpricedata = ev?.id;
        this.cruiseFiltersService.cruisemaxprice(this.cruisemaxpricedata, this.mode !== 'home');
    }

    async cruisecabincatresult(ev) {
        this.cruisecabincatdata = ev?.id;
        this.cruiseFiltersService.cruisecabincat(this.cruisecabincatdata, this.mode !== 'home');
    }

    async makeSearch() {
        this.cruiseFiltersService.changeUrl();
    }

    closeextras(): void {
        this.closeModal.emit(true);
    }

    async resetAll() {
        this.cruiseFiltersService.resetAllExtrasHome();
    }

    async resetAllExtra() {
        this.cruiseFiltersService.resetAllExtras();
    }
}
